export default {
  selectedUniversity: state => state.selectedUniversity
}
